"use client";

import React, { useState } from "react";
import { profile } from "@/lib/data";
import Link from "next/link";
import { HiArrowLeft, HiDownload } from "react-icons/hi";

export default function ResumePage() {
  const [loading, setLoading] = useState(true);
  
  // Convert Google Drive download link to preview link
  const getPreviewUrl = (url: string) => {
    if (url.includes("drive.google.com")) {
      const fileId = url.match(/[-\w]{25,}/);
      if (fileId) {
        return `https://drive.google.com/file/d/${fileId[0]}/preview`;
      }
    }
    return url;
  };

  const previewUrl = getPreviewUrl(profile.resumeLink);

  return (
    <div className="min-h-screen bg-gray-900 text-white py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-center mb-8 gap-4">
          <Link
            href="/#resume"
            className="flex items-center gap-2 text-white/80 hover:text-white transition-colors"
          >
            <HiArrowLeft className="text-xl" />
            <span>Back to Portfolio</span>
          </Link>

          <a
            href={profile.resumeLink}
            download
            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-all font-medium"
          >
            <HiDownload className="text-xl" />
            Download Resume
          </a>
        </div>

        {/* PDF Viewer */}
        <div className="bg-white/5 rounded-xl p-4 sm:p-8 relative">
          {loading && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-900/50 rounded-xl z-10">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
            </div>
          )}
          
          <div className="w-full" style={{ height: "calc(100vh - 300px)", minHeight: "600px" }}>
            <iframe
              src={previewUrl}
              className="w-full h-full rounded-lg"
              title="Resume Preview"
              onLoad={() => setLoading(false)}
              onError={() => setLoading(false)}
            />
          </div>

           <div className="text-center mt-6 text-white/60 text-sm">
             <p>
               "The only way to do great work is to love what you do. I love turning ideas into code." 💻
             </p>
           </div>
        </div>
      </div>
    </div>
  );
}

